import { createFileRoute } from "@tanstack/react-router";
import { TopicPage } from "@/components/site/TopicPage";
import logoAsset from "@/assets/lifewestway-logo.png.asset.json";
import { makeSeoDescription } from "@/lib/seo-description";

const SITE = "https://lifewestway.com";
const TITLE = "Expat Tax Guides 2026 | LifeWestWay";
const DESC = "Country-specific tax residency, filing deadlines, brackets, and reliefs for new arrivals.";
const URL_ = `${SITE}/tax`;
const IMAGE = `${SITE}${logoAsset.url}`;

export const Route = createFileRoute("/tax")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: makeSeoDescription(DESC) },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: makeSeoDescription(DESC) },
      { property: "og:type", content: "article" },
      { property: "og:url", content: URL_ },
      { property: "og:image", content: IMAGE },
      { property: "og:image:alt", content: "LifeWestWay" },
      { property: "og:site_name", content: "LifeWestWay" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: makeSeoDescription(DESC) },
      { name: "twitter:image", content: IMAGE },
    ],
    links: [{ rel: "canonical", href: "https://lifewestway.com/tax" }],
  }),
  component: () => (
    <TopicPage
      topic="Tax"
      intro="Residency status, filing deadlines, brackets, and the reliefs most commonly missed in your first year abroad."
    />
  ),
});
